<template>
  <img
    :src="item.source"
    class="node-overlay"
    :style="getItemStyle(item)"
    alt="..."
  >
</template>

<script>
export default {
  name: 'NodeOverlay',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getItemStyle(item) {
      const properties = [ 'top', 'left', 'width', 'height' ];
      let style = '';
      properties.forEach(prop => {
        if (item[prop] !== undefined) {
          style += `${prop}:${item[prop]}rem;`
        }
      });
      return style;
    },
  },
}
</script>
